module.exports = __webpack_public_path__ + "img/2.42ab4d56.png";